module.exports = __webpack_public_path__ + "static/media/chart-of-account-default-image.c2f66df6.png";